//baseUrl
export const ApiBaseUrl = "https://dev-api.simplerenovate.io/";

export const ClientIdGoogleLogin= "717763838069-1r2bfvpogua4tccbjuh6r4slucltdtgi.apps.googleusercontent.com";
//export const ApiBaseUrl = "http://localhost:4002/";
export const SocketBaseUrl = "wss://dev-api.simplerenovate.io/";
// export const SocketBaseUrl = "ws://localhost:4002/";
export const stripeKey = "pk_test_51S5xXK0QXmPtx67xVrZC2b6Qfbq0LNeBLDryPbIbaLGYsWvM3WPy5dUAekTwtBKE2okyBT3a70MmSgiBl4sM3b6p003Z7uNvbR";
//export const stripeKey = "pk_live_51TRw100bEFWeLzZ9cN9twPNfxhRlu5kkCqzwWlBaCksFt9vkONNhMoW8cSOCCd9SqnVZdrRJuVR3KKJ0WusstFZ200VVghNZge";
// Live
// export const monthlyPlanPriceId= 'price_1TRwbJ0bEFWeLzZ9tpNAaV9V';
// export const yearlyPlanPriceId= 'price_1TRwYs0bEFWeLzZ9x5zMnPDS';
// export const areaSubScriptionPriceId= 'price_1TRwe10bEFWeLzZ9dF8jYR8g'; // $9
//export const areaSubScriptionPriceId= 'price_1TP72GP2HCUUNsIcuCSEqtoY'; // $1


// Test
export const monthlyPlanPriceId= 'price_1TRwlN0pB6E2h4xumu2Ggp5i';
export const yearlyPlanPriceId= 'price_1TRwme0pB6E2h4xux9Zgc2AL';
export const areaSubScriptionPriceId= 'price_1TRwjf0pB6E2h4xulfx5kcKq'


// sandbox
// export const monthlyPlanPriceId= 'pri_01kqed0sjy0caq43jysnrms0hp';
// export const yearlyPlanPriceId= 'pri_01kqed1ysxth4ght54017mms43';
// export const areaSubScriptionPriceId= 'pri_01kqekkqcd7ca21mjnbx932x2t'


//API Name
export const sendEmailVerificationCodeApi = "v1/common/sendEmailVerification";
export const verifyEmailVerificationCode = "v1/common/verifyEmail";
export const sendEmailVerificationV2Api = "v2/user/sendEmailVerification";
export const verifyEmailVerificationV2Api = "v2/user/verifyEmailVerification";
export const sendMobileVerificationCodeApi =
  "v1/common/sendVerificationCodeEmailAndPhone";
export const verifyMobileVerificationCode = "v1/common/verifyPhoneNumber";
export const createProfileProfessional = "v1/professional/createProfile";
export const createProfileClient = "v1/user/createProfile";
export const getProfileProfessional = "v1/professional/getProfile";
export const getProfileClient = "v1/user/getProfile";
export const getServicesProfessional = "v1/professional/getServices";
export const loginProfessional = "v1/professional/login";
export const loginClient = "v1/user/login";
export const signUpClient = "v1/user/signUp";
export const signUpProfessional = "v1/professional/signUp";
export const sendEmailVerificationV2ProfessionalApi =
  "v2/professional/sendEmailVerification";
export const verifyEmailVerificationV2ProfessionalApi =
  "v2/professional/verifyEmailVerification";
export const loginPhoneProfessional = "v1/professional/loginWithPhone";
export const loginPhoneClient = "v1/user/loginWithPhone";
export const verifyPhoneLoginClient = "v1/user/verifyLoginWithPhone";
export const verifyPhoneLoginProfessional =
  "v1/professional/verifyLoginWithPhone";
export const dashboardProfessional = "v1/professional/dashboard";
export const dashboardClient = "v1/user/dashboard";
export const uploadMediaApi = "v1/upload";
export const socialLoginClient = "v1/user/socialLogin";
export const socialLoginProfessional = "v1/professional/socialLogin";
export const socialLoginFromGetStarted = "v1/professional/socialLoginFromGetStarted";
export const updateProfileProfessional = "v1/professional/updateProfile";
export const getJobListForProfessional = "v1/professional/getJobs";
export const getPromotionListForProfessional = "v1/professional/getPromotions";
export const createPromotionForProfessional = "v1/professional/addPromotion";
export const updatePromtionForProfessional = "v1/professional/updatePromotion";
export const getBoostBidsForProfessional = "v1/professional/getBoostBids";
export const submitBidByProfessional = "v1/professional/addBid";
export const setBookMarkJobByProfessional = "v1/professional/bookmarkJob";
export const updateProfileClient = "v1/user/updateProfile";

export const clientLogout = "v1/user/logout";
export const professionalLogout = "v1/professional/logout";

export const deleteAccountClient = "v1/user/deleteAccount";
export const deleteAccountProfessional = "v1/professional/deleteAccount";

export const updatePasswordClient = "v1/user/updatePassword";
export const updatePasswordProfessional = "v1/professional/updatePassword";

export const updateNotificationSettingClient =
  "v1/user/updateNotificationSettings";
export const updateNotificationSettingProfessional =
  "v1/professional/updateNotificationSettings";

export const getSettings = "v1/common/getSettings";

export const getBidListingProfessional = "v1/professional/getBids";
export const getBidListingClient = "v1/user/getBids";

export const updateBidProfessional = "v1/professional/updateBidUpdates";
export const getBidDetailsProfessional = "v1/professional/bidDetails";
export const setJobSchedule = "v1/professional/setJobSchedule";

export const chatHistoryListingProfessional =
  "v1/professional/chatHistoryListing";
export const chatDetailsProfessional = "v1/professional/chatHistoryDetails";

export const chatHistoryListingClient = "v1/user/chatHistoryListing";
export const chatDetailsClient = "v1/user/chatHistoryDetails";

export const getJobDetailsWithBidProfessional = "v1/professional/jobDetail";
export const getBlogList = "v1/common/getBlogs";
export const getBlogDetail = "v1/common/blogDetails";

export const createStripeConnectAccount =
  "v1/professional/createStripeConnectAccount";
export const createStripeSessionNewProfessional =
  "v1/professional/createStripeSessionNew";
export const createStripeSessionSubscriptionProfessional =
  "v1/professional/createStripeSessionSubscription";
export const requestPaymentByProfessional = "v1/professional/requestPayment";

export const getJobPaymentRequestsProfessional =
  "v1/professional/getPaymentRequests";
export const getJobPaymentRequestsClient = "v1/user/getPaymentRequests";
export const getJobPaymentHistoryClient = "v1/user/getPaymentHistoryData";
export const getJobPaymentHistoryProfessional =
  "v1/professional/getPaymentHistory";
export const updatePaymentRequestByClient = "v1/user/updatePaymentRequest";

export const getSubscriptionDataProfessional =
  "v1/professional/getSubscriptionData";
export const updateSubscriptionDataProfessional =
  "v1/professional/updateSubscription";

export const getCreditHistoryProfessional = "v1/professional/getCreditHistory";
export const getCreditHistoryClient = "v1/user/getCreditHistory";

export const getServicesCommon = "v1/common/getServices";

export const getContractProfessional = "v1/professional/contract";

export const getPromotionDetailsProfessional =
  "v1/professional/getPromotionDetails";

export const getNotificationProfessionalHeaders =
  "v1/professional/notificationsForHeader";
export const getNotificationClientHeaders = "v1/user/notificationsForHeader";

export const getNotificationsProfessional = "v1/professional/notifications";
export const getNotificationsClient = "v1/user/notifications";

export const veriffStartVerification = "create-veriff-session";

export const contactUs = "v1/common/contactUs";

export const forgotPassword = "v1/common/forgotPassword";
export const verifyForgotPassword = "v1/common/verifyForgotPassword";
export const updatePassword = "v1/common/updatePassword";

export const addComingSoonUsers = "v1/common/addComingSoonUsers";


export const getServiceAreas = "v1/professional/getServiceAreas";

export const tryAgainPaymentForServiceAreaSubscription = "v1/professional/tryAgainPaymentForServiceAreaSubscription";
export const checkStatusForServiceAreaSubAfterTryAgain = "v1/professional/checkStatusForServiceAreaSubAfterTryAgain";
